import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { VIEWS } from '../constants';

const useViewOptions = () => {
  const { t } = useTranslation('sonar');

  return useMemo(
    () => [
      { label: t('narrow'), value: VIEWS.NARROW },
      { label: t('broad'), value: VIEWS.BROAD },
      { label: t('groups'), value: VIEWS.GROUPS },
    ],
    [t],
  );
};

export default useViewOptions;
